import { render, staticRenderFns } from "./SkillSlot.vue?vue&type=template&id=147cde8a&"
import script from "./SkillSlot.vue?vue&type=script&lang=js&"
export * from "./SkillSlot.vue?vue&type=script&lang=js&"
import style0 from "./SkillSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports